import { BehaviorSubject, Subscription } from "rxjs";
import { Observable } from "rxjs";
import { Component, OnInit, Input, Output, EventEmitter, NgZone } from "@angular/core";
import { UserRolesService } from "src/app/services/settings-services/user-roles.service";
import { GeneralService } from "src/app/services/general.service";
import { environment } from "src/environments/environment";
import { BillingService } from "src/app/registration/services/billing.service";
import * as $ from "jquery";
@Component({
  selector: "app-add-more-users-to-license",
  templateUrl: "./addMoreUsers.component.html",
  styleUrls: ["./addMoreUsers.component.css"],
})
export class AddMoreUsersToLicenseComponent implements OnInit {


  @Input() licencesDataSource;
  @Input() numberOfUser;
  @Input() selectedBillingId;
  @Input() upgradeLoading;
  @Input() org;
  @Input() user;
  @Output() callback: EventEmitter<any> = new EventEmitter<any>(null);
    currentLicense: any;
    userCostValue;

  constructor(
    private userRoles: UserRolesService,
    private gs: GeneralService,
    private ngZone: NgZone,
    public billingService: BillingService,
  ) { }

  ngOnInit() {

  }

  onSelectBilling($event){

    this.currentLicense = $event;
    this.getUserValue(this.numberOfUser);
  }

  getUserValue(numberOfUser) {    
    const {id} = this.currentLicense;
    if(id && id > 0 && numberOfUser && numberOfUser > 0 && this.selectedBillingId > 0){
      this.upgradeLoading = true;
      this.userRoles.getAdditionalUserValueByBill(numberOfUser, id).subscribe((response: any) => {
        this.userCostValue = response.payload;
        this.upgradeLoading = false;
      })
    }    
  }

  proceed(){
    this.paystackInit();
    // this.callback.emit({ type: "selectedrows", data: {} });
  }
  OnDestroy() {
  }

  paystackInit() {
    if(this.selectedBillingId === 0){
      alert('No license was selected')
      return;
    }
    const bills = this.licencesDataSource.filter(bill => bill.id === this.selectedBillingId);
    if(!bills || bills.length ===0){
      alert('No license was selected from list')
      return;
    }
    this.currentLicense = bills[0];
    const winPaystackPop = (window as any).PaystackPop;
    const { currency, paymentMethod, licenseID } = this.currentLicense;
    const metadata = {
      orgId: this.org.id,
      licenseId: licenseID,
      userID: this.user.id,
      numberOfUsers: this.numberOfUser,
      referrer: `${window.origin}/reg/plans`,
      tenantEmail: this.org.email,
      tenantName: this.org.name,
      autoRenew: false,
      billPlanType: paymentMethod,
      paymentType: "ADD_MORE_USERS_TO_LICENSE"
    };
    const amount = Math.round(this.userCostValue.cost * 100);
    if (winPaystackPop) {
      const handler = winPaystackPop.setup({
        key: environment.paystackKey,
        email: this.org.email,
        amount,
        metadata: { ...metadata },
        currency: currency,
        callback: (response: any) => this.ngZone.run(() => {
          this.confirmPayment(response);
        })
      });
      handler.openIframe();
    } else {
      const swtData = { title: 'Opps!', html: 'Network error occured, reload page and try again' };
      this.gs.sweetAlertHTML(swtData.title, swtData.html);
    }
  }


  confirmPayment(response) {
    const { id: orgId } = this.org;
    const payload = { reference: response.reference, orgId };
    this.upgradeLoading = true;
    this.billingService.comfirmPaystackPayment(payload.reference).subscribe(res => {
      if (res.payload && res.payload.data.status == 'success') {
        this.numberOfUser = ""
        $("#closeUpgradeBtn").click();
        this.gs.sweetAlertSucess('Payment  successful')
        // this.updateOrgLicense(res);
      } else {
        this.gs.sweetAlertHTML('Payment Status', 'Payment not successful')
      }
    }, err => {
      this.gs.sweetAlertError(this.gs.getErrMsg(err));
    }).add(() => {
      this.upgradeLoading = false
    })
  }
}